import styles from './ProductTags.module.css';

interface DecisionFactor {
  label: string;
  // add other properties if needed
}

interface ProductTagsProps {
  decisionFactors?: { value: DecisionFactor[] };
  showDescription?: boolean;
}

const ProductTags = ({ decisionFactors, showDescription }: ProductTagsProps) => {
  if (!decisionFactors?.value) {
    return null;
  }

  let factors = decisionFactors?.value.slice(0, 2);
  // Check if any of the factors have a label longer than 13 characters
  const longFactors = factors.filter((factor) => factor.label.length > 13);
  // If there are long factors, slice the array to only include the first one
  if (longFactors.length > 0) {
    factors = factors.slice(0, 1);
  }

  return (
    <div className={styles.tagsContainer}>
      <span className={styles.tagContent}>
        {factors.map((value) => (
          <div className={styles.tag} key={value.label}>
            {value.label}
          </div>
        ))}
      </span>
    </div>
  );
};

export default ProductTags;
